import { take, put } from "redux-saga/effects";
import { GET_ASSIGNMENT_STATUS_DETAIL, getAssignmentStatusDetailActions } from "src/redux/actions/assignments";

// services
import { getGetAssignmentDetails } from "src/services/http/assignments";

// types
import { GetAssignmentStatusDetailResponseTypes } from "src/redux/actions/assignments/types";

import * as Effects from "redux-saga/effects";

const call: any = Effects.call;

function* watchAssignmentStatusDetailRequest() {
  while (true) {
    const { payload } = yield take(GET_ASSIGNMENT_STATUS_DETAIL.REQUEST);

    try {
      const result: GetAssignmentStatusDetailResponseTypes = yield call(getGetAssignmentDetails, {
        assignmentId: payload.id
      });
      yield put(getAssignmentStatusDetailActions.success(result));
    } catch (e) {
      console.log(e, "error");
      yield put(getAssignmentStatusDetailActions.error(e as any));
    }
  }
}

export default watchAssignmentStatusDetailRequest;
